import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Search } from "lucide-react";

export function PlateLookupCard() {
  const [cfg, setCfg] = useState(null);
  const [f, setF] = useState({ provider: "", api_key: "" });
  useEffect(() => { api.get("/shop-settings/plate-lookup").then(({ data }) => { setCfg(data); setF({ provider: data.provider || "", api_key: "" }); }).catch(() => setCfg({})); }, []);
  const save = async (clear) => {
    try { const { data } = await api.put("/shop-settings/plate-lookup", { provider: f.provider, api_key: clear ? "" : f.api_key || undefined }); setCfg(data); setF((p) => ({ ...p, api_key: "" })); toast.success("Salvo"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  if (!cfg) return null;
  return (
    <section data-testid="plate-lookup-card" className="rounded-2xl border border-card2-border bg-card2 p-4 space-y-3">
      <div className="flex items-center gap-2 font-bold text-zinc-100"><Search className="h-4 w-4" /> Consulta por placa <span className="text-[10px] rounded-full border border-zinc-700 px-2 text-zinc-400">{cfg.configured ? "chave salva" : "desativada"}</span></div>
      <p className="text-xs text-zinc-500">Recurso pago de terceiros (ainda não ativo). Sem chave, nada aparece no cadastro do veículo.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <Input data-testid="plate-provider" value={f.provider} onChange={(e) => setF((p) => ({ ...p, provider: e.target.value }))} placeholder="Provedor" className="bg-zinc-900 border-zinc-800" />
        <Input data-testid="plate-key" type="password" value={f.api_key} onChange={(e) => setF((p) => ({ ...p, api_key: e.target.value }))} placeholder={cfg.configured ? "•••••• (manter)" : "Chave de API"} className="bg-zinc-900 border-zinc-800" />
      </div>
      <div className="flex gap-2"><Button size="sm" data-testid="plate-save" onClick={() => save(false)} className="bg-green-brand text-white">Salvar</Button>
        {cfg.configured && <Button size="sm" variant="outline" data-testid="plate-clear" onClick={() => save(true)} className="bg-zinc-900 border-zinc-800">Remover chave</Button>}</div>
    </section>
  );
}
